var React = require( 'react' );
var PropTypes = require('prop-types');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var Billboard = createReactClass({
	mixins: [PureRenderMixin],

  render: function(){
      const {imageUrl = "", linkUrl = ""} = this.props.ad;

    // If no ad imageUrl, return null
    if (!imageUrl) return null;

    return (
		<section id="ad-billboard">
          <div className="row">
          	<div className="text-center" style={{ margin: "30px", maxHeight: "250px" }}><a href={linkUrl} target="_ad"><img src={imageUrl} alt="Ad" /></a></div>
          </div>
		</section>
    )
  }
});

Billboard.propTypes = {
  imageUrl: PropTypes.string,
  linkUrl: PropTypes.string,
};

module.exports = Billboard;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/billboard.jsx